import {getJsonObjectCachedOrFetch} from "./ServiceHelpers";

const clientAppVersionKey = "clientAppVersion";

export const getAppVersion = async () => {
    const server = await getJsonObjectCachedOrFetch("api/appversion", "serverAppVersion");
    const clientData = localStorage.getItem(clientAppVersionKey);
    const client = clientData ? JSON.parse(clientData) : null;
    return {server: server, client: client};
}

export const reloadAppIfClientAndServerVersionsDiffer = () => {
    getAppVersion().then(appVersion => {
        if (appVersion.server.gitHash !== appVersion.client?.gitHash) {
            console.log("New app version available; reloading...");
            localStorage.setItem(clientAppVersionKey, JSON.stringify(appVersion.server));
            window.location.reload();
        }
    });
}
